<template>
  <div class="dashboard-grid-list-toggle marker--dashboard-grid-list-toggle row">
    <div
      :class="{'active': isGridActive }"
      class="icon-wrapper col-6"
      @click="changeActive('grid')"
    >
      <i class="ddi ddi-grid" />
    </div>
    <div
      :class="{'active': !isGridActive }"
      class="icon-wrapper col-6"
      @click="changeActive('table')"
    >
      <i class="ddi ddi-list" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DashboardGridListToggle',

  props: {
    viewType: {
      type: String,
      default: 'grid',
    },
  },

  emits: ['update:viewType'],

  computed: {
    isGridActive(): boolean {
      return this.viewType === 'grid'
    },
    internalViewType: {
      get(): any {
        return this.viewType
      },
      set(newValue: any) {
        this.$emit('update:viewType', newValue)
      },
    },
  },

  methods: {
    changeActive(type: string) {
      this.internalViewType = type
    },
  },
})
</script>

<style lang="scss">
.dashboard-grid-list-toggle {
  height: 28px;
  color: var(--color-text-third);
  border: 1px solid $color--gray-60;
  border-radius: 3px;

  @include media-breakpoint-up(lg) {
    width: 63px;
    height: 23px;
  }

  &:hover {
    cursor: pointer;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .active {
    color: white;
    background: $color--gray-60;
  }

  .ddi {
    font-size: 12px;
  }
}
</style>
